export const SPA_LOCATIONS = [
  { city: 'Delhi', image: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=400', isCenter: true },
  { city: 'Gurgaon', image: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=400', isCenter: true },
  { city: 'Noida', image: 'https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=400', isCenter: true },
  { city: 'Ghaziabad', image: 'https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=400', isCenter: true },
];

export const DEFAULT_LOCATIONS = ['Delhi', 'Gurgaon', 'Noida', 'Ghaziabad', 'In Home'];

export const GENDER_OPTIONS = ['Male', 'Female', 'Non-binary', 'Prefer not to say'];

export const ADDRESS_LABELS = ['Home', 'Work', 'Other'];

export const WALLET_MAX_PERCENT = 0.10;
export const WALLET_MAX_AMOUNT = 100;

export const CONTACT = {
  phone: '+91 99905 53874',
  email: 'support@recovry.in',
  address: 'Recovry, GDA Market, Sector 23, Sanjay Nagar, Ghaziabad',
  whatsapp: 'https://wa.me/919990553874',
};

export const BUSINESS_HOURS = [
  { days: 'Monday - Friday', time: '9:00 AM - 8:00 PM' },
  { days: 'Saturday - Sunday', time: '10:00 AM - 6:00 PM' },
];
export const SERVICE_HOURS = [
  { days: 'Monday - Sunday', time: '7:00 AM - 10:00 PM' },
];

// Fallback only — the live payee comes from the backend site config
// (`upi_config`). Kept in sync with it so the pre-fetch fallback is correct.
export const UPI_CONFIG = {
  receiverUpiId: '7827209820@pthdfc',
  receiverName: 'Recovry',
  currency: 'INR',
};

export const WELLNESS_TIPS = [
  'Take deep breaths for 2 minutes after your session.',
  'Drink water to stay hydrated and flush toxins.',
  'Gentle stretching helps maintain your relaxation.',
  'Try to sleep early tonight for better recovery.',
];

export const FULL_BODY_PRICES: Record<number, number> = { 60: 749, 90: 1109 };
export const PACKAGE_DISCOUNT = 0.05;
export const PACKAGE_SIZE = 5;
